module.exports = __webpack_public_path__ + "img/score_05.c7d3ad80.svg";